import React, { createContext, useReducer } from "react";
import { Animation } from "../../../../TypesAndConstants/types";

interface TopMenuState {
  animation: Animation;
  displayPreview: boolean;
}

const initState: TopMenuState = {
  animation: Animation.None,
  displayPreview: true,
};

type topMenuActions = "set_animation" | "set_display_preview";

export type dispatchColorAction = {
  type: topMenuActions;
  value: any;
};

export const MenuContext = createContext<{
  state: TopMenuState;
  dispatch: (action: dispatchColorAction) => void;
}>({
  state: initState,
  dispatch: () => {},
});

const menuReducer = (
  state: TopMenuState = initState,
  action: dispatchColorAction
) => {
  switch (action.type) {
    case "set_display_preview":
      return { ...state, displayPreview: !state.displayPreview };
    default:
      return state;
  }
};

export const ContextConsumer = MenuContext.Consumer;

export const ContextProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(menuReducer, initState);

  return (
    <MenuContext.Provider value={{ state, dispatch }}>
      {children}
    </MenuContext.Provider>
  );
};
